"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var web_bi_logger_1 = require("web-bi-logger");
var mandatoryFieldsMapping = {
    cardNumber: 'number',
    expire: 'expiration',
    cvc: 'additional_information.cvv',
    cardHolderName: 'additional_information.holder_name',
    holderId: 'additional_information.holder_id',
};
var BiLogger = /** @class */ (function () {
    function BiLogger() {
        var _this = this;
        this.init = function (_a) {
            var appId = _a.appId, appInstanceId = _a.appInstanceId, orderSnapshotId = _a.orderSnapshotId, visitorId = _a.visitorId, msid = _a.msid, host = _a.host, type = _a.type;
            var factoryConfig = host ? { host: host, endpoint: 'cashier-ugc' } : { endpoint: 'cashier-ugc' };
            if (type === 'mobile') {
                // TODO we need to implement bi for mobile
                _this.logger = {
                    log: function () { return null; }
                };
            }
            else {
                _this.logger = web_bi_logger_1.default.factory(factoryConfig).setDefaults({
                    src: 64,
                    appId: appId,
                    appInstanceId: appInstanceId,
                    msid: msid,
                    orderSnapshotId: orderSnapshotId,
                    visitorId: visitorId,
                }).logger();
            }
        };
        this.log = function (_a) {
            var evid = _a.evid, rest = __rest(_a, ["evid"]);
            return _this.logger && _this.logger.log(__assign({ evid: evid }, rest));
        };
        this.mandatoryFieldsLoaded = function (_a) {
            var mandatoryFieldsList = _a.mandatoryFieldsList, orderId = _a.orderId, paymentMethod = _a.paymentMethod, appId = _a.appId, appInstanceId = _a.appInstanceId;
            // List of mandatory fields to be fulfilled by buyer
            var evid = 164;
            mandatoryFieldsList = _this.stringifyMandatoryFields(mandatoryFieldsList);
            _this.log({ evid: evid, mandatoryFieldsList: mandatoryFieldsList, orderId: orderId, paymentMethod: paymentMethod, appId: appId, appInstanceId: appInstanceId });
        };
        this.mandatoryFieldsValidation = function (_a) {
            var status = _a.status, invalidFields = _a.invalidFields, paymentMethod = _a.paymentMethod, orderId = _a.orderId, paymentProvider = _a.paymentProvider;
            // The result of Payment Method Validation
            var evid = 165;
            var reason = _this.stringifyMandatoryFields(invalidFields);
            _this.log({ evid: evid, status: status, paymentMethod: paymentMethod, orderId: orderId, reason: reason, paymentProvider: paymentProvider });
        };
        /**
         * Convert fields loaded from server and from validation to same format
         *
         * @param {Array<string>} fields
         * @returns {string}
         */
        this.stringifyMandatoryFields = function (fields) {
            var mappedFields = Object.keys(mandatoryFieldsMapping).map(function (field) { return mandatoryFieldsMapping[field]; });
            fields = fields.map(function (field) {
                if (mappedFields.indexOf(field) !== -1) {
                    return field;
                }
                else {
                    field = field.split('.').pop();
                    return mandatoryFieldsMapping[field] || "description.billingAddress." + field;
                }
            });
            return fields.join(',');
        };
    }
    return BiLogger;
}());
exports.default = (new BiLogger());
//# sourceMappingURL=biLogger.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/utils/biLogger.js
// module id = 119
// module chunks = 0 1